import React from 'react';
import { Image, Rect } from 'react-konva';
import { getWidthKonvaText, isMobileTablet } from '../../library/calc';
import { fontFamily } from '../../library/constants';

let okLabelWidthInToolTip = undefined;
let confirmLabelWidthInToolTip = undefined;
const move = -3;
const fontSize = 3.5;
const lineHeight = 1.2;
const fontStyle = 'bold';
const contentStr = 'A GEDCOM import is in progress for this profile. You should not add onto this profile until the import is finished.';
const buildShowTipObj = ( {
  n,
  pr_id,
  importStr,
  confirmLabelWidthInToolTip,
  okLabelWidthInToolTip,
  unsetNodeObjGedcom,
  ignoreStr,
  hideToolTip,
  content,
}) => {

  const doConfirmCallback = ({n, pr_id}) => {
    if(typeof(window.continueGedcomImport) !== 'undefined') window.continueGedcomImport(pr_id)
  }

  const doOkCallback = ({n, pr_id}) => {
    unsetNodeObjGedcom({node:n});
    hideToolTip();
    if(typeof(window.ignoreGedcomImport) !== 'undefined') window.ignoreGedcomImport(pr_id)
  }

  const obj = {
      node: n,
      placement: 'over',
      shiftLeftOnToolTip: -5,
      shiftTopOnToolTip: 0,
      bubbleWidth: 100,
      confirmLabelWidthInToolTip,
      confirmLabelInToolTip: importStr,
      confirmCallbackInToolTip: () => {
        doConfirmCallback({n, pr_id});
      },
      okLabelWidthInToolTip,
      okLabelInToolTip: ignoreStr,
      okCallbackInToolTip: () => {
        doOkCallback({n, pr_id});
      },
      content,
  }

  return obj;
}


export class Gedcom extends React.Component { //https://binf.snipcademy.com/lessons/dna-sequencing-techniques

  render() {

      let {
        left,
        top,
        gc,
      } = this.props;

      const {
        n,
        pr_id,
        cursorBecomesMove,
        cursorBecomesPointer,
        gedcomImg,
        showToolTipFor,
        translatedLabels,
        stopStageClickPropagation,
        unsetNodeObjGedcom,
        hideToolTip,
        skipZoomInOutSteppingNow,
      } = this.props;

    const content = translatedLabels[contentStr].translatedLabel;

    const ignoreStr = translatedLabels['Skip Import'].translatedLabel;
    const importStr =translatedLabels['Import'].translatedLabel

    okLabelWidthInToolTip = getWidthKonvaText({str: ignoreStr, fontSize, fontFamily, fontStyle, lineHeight});
    confirmLabelWidthInToolTip = getWidthKonvaText({str: ignoreStr, fontSize, fontFamily, fontStyle, lineHeight});

    left += -3;
    top += move;

    let obj = buildShowTipObj({
      n,
      pr_id,
      importStr,
      confirmLabelWidthInToolTip,
      okLabelWidthInToolTip,
      unsetNodeObjGedcom,
      ignoreStr,
      hideToolTip,
      content
    });

    delete obj.confirmLabelWidthInToolTip;
    delete obj.confirmLabelInToolTip;
    if(parseInt(gc, 10) === 1) {
      delete obj.okLabelWidthInToolTip;
      delete obj.okLabelInToolTip;
      obj.bubbleWidth = 40;
    }

    return <Image
      image={gedcomImg}
      x={left}
      y={top}
      scaleX={.1}
      scaleY={.1}
      width={8*10}
      height={8*10}
      opacity={1}
      cursor={'pointer'}

      onClick={()=>{
        stopStageClickPropagation({fromWhere: 'gedcom'});
        skipZoomInOutSteppingNow();
        obj.toolTipDelay = 0;
        showToolTipFor(obj)
      }}

      onMouseenter={()=>{
        skipZoomInOutSteppingNow();
        cursorBecomesPointer();
        showToolTipFor(obj)
      }}
      onMouseleave={()=>{
        cursorBecomesMove();
      }}

    />;
  }
}

export class GedcomTransparentBox extends React.Component {

  render () {

    let {
      n,
      left,
      top,
      pr_id,
      gc,
      showToolTipFor,
      translatedLabels,
      unsetNodeObjGedcom,
      hideToolTip,
      skipZoomInOutSteppingNow,
      userTouchedNode,
      stopStageClickPropagation,
    } = this.props;


    const content = translatedLabels[contentStr].translatedLabel;
    const ignoreStr = translatedLabels['Skip Import'].translatedLabel;
    const importStr =translatedLabels['Import'].translatedLabel;

    const obj = buildShowTipObj({
                  n,
                  pr_id,
                  importStr,
                  confirmLabelWidthInToolTip,
                  okLabelWidthInToolTip,
                  unsetNodeObjGedcom,
                  ignoreStr,
                  hideToolTip,
                  content,
                  userTouchedNode,
                });

    // gc = 2;
    delete obj.confirmLabelWidthInToolTip;
    delete obj.confirmLabelInToolTip;
    if(gc === 1) {
      delete obj.okLabelWidthInToolTip;
      delete obj.okLabelInToolTip;
      obj.bubbleWidth = 40;
    }

    left += -4;
    top += move - 1;
/*
              fill={'red'}
              opacity={.4}

 */
    return  <Rect
              x={left}
              y={top}
              width={9}
              height={9}
              onTouchStart={()=>{
                userTouchedNode({
                  node:n,
                  callback: ()=>{
                    if(isMobileTablet()) {
                      stopStageClickPropagation({fromWhere: 'gedcom'});
                      skipZoomInOutSteppingNow();
                      obj.toolTipDelay = 0;
                      showToolTipFor(obj)
                    }
                  },
                  fromWhere: 'GedcomTransparentBox'
                });
              }}
            />

  }
}

